<ax-number-box [(text)]="value"  *ngIf="visible" [placeholder]="placeholder" [readonly]="readonly" type="number">
</ax-number-box> 